import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const GradientEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const opacityValue = effectOpacity / 100

  const gradientString = useMemo(() => {
    if (effectColors.length === 0) return 'linear-gradient(135deg, #6366f1, #8b5cf6, #ec4899)'
    if (effectColors.length === 1) return `linear-gradient(135deg, ${effectColors[0]}, ${effectColors[0]})`
    return `linear-gradient(135deg, ${effectColors.join(', ')})`
  }, [effectColors])

  return (
    <motion.div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        background: gradientString,
        backgroundSize: '200% 200%',
        opacity: opacityValue,
      }}
      animate={{
        backgroundPosition: ['0% 0%', '100% 100%', '0% 0%'],
      }}
      transition={{
        duration: 10 * (100 / Math.max(effectSpeed, 1)),
        repeat: Infinity,
        ease: 'linear',
      }}
    />
  )
})
GradientEffect.displayName = 'GradientEffect'
